import React, { useState } from "react";
import {
  Stack,
  Typography,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Modal,
} from "@mui/material";
import { useTranslation } from "react-i18next";

function AddMinor(props) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    birthDateDay: "",
    birthDateMonth: "",
    birthDateYear: "",
    relation: "",
  });

  const { t, i18n } = useTranslation();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const handleChange = (e) => {
    console.log(e.target);
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  console.log(formData);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    const validateFormData = Object.values(formData).every(
      (value) =>
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0) &&
        !(
          typeof value === "object" &&
          value !== null &&
          Object.keys(value).length === 0
        )
    );
    console.log(validateFormData);
    if (validateFormData) {
      props.onValueChange(formData);
      setFormData({
        firstName: "",
        lastName: "",
        birthDateDay: "",
        birthDateMonth: "",
        birthDateYear: "",
        relation: "",
      });
      setOpen(false);
    }

    // props.onValueChange(formData);
  };

  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const years = Array.from(
    { length: 19 },
    (_, i) => new Date().getFullYear() - i
  );

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        sx={{ marginTop: "30px" }}
        onClick={handleOpen}
      >
        {t("add_minor")}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-title" variant="h6" component="h2">
            {t("add_a_minor")}
          </Typography>
          <Stack
            direction="column"
            //   alignItems="end"
            spacing={2}
            padding={2}
            component="form"
            useFlexGap
            sx={{ flexWrap: "wrap" }}
            onSubmit={handleSubmit}
            maxWidth="600px"
          >
            <Box
              sx={{ paddingBottom: "5px", width: "100%", textAlign: "center" }}
            >
              <label> {t("child_info")}</label>
            </Box>
            <TextField
              label={t("first_name")}
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
              variant="standard"
              sx={{ width: "200px" }}
            />
            <TextField
              label={t("last_name")}
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
              variant="standard"
              sx={{ width: "200px" }}
            />

            <Stack direction="row" alignItems="end">
              <Box sx={{ paddingBottom: "5px" }}>
                <label>{t("DOB")}: </label>
              </Box>

              <Stack
                direction="row"
                component="form"
                sx={{ width: "300px", marginLeft: "0px" }}
              >
                <FormControl variant="standard" sx={{ minWidth: 80 }}>
                  <InputLabel id="demo-simple-select-standard-label"></InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={formData.birthDateMonth}
                    onChange={handleChange}
                    label="MM"
                    required
                    sx={{ width: "60px" }}
                    name="birthDateMonth"
                    key={0}
                  >
                    {[
                      ["01", t("jan")],
                      ["02", t("feb")],
                      ["03", t("mar")],
                      ["04", t("apr")],
                      ["05", t("may")],
                      ["06", t("jun")],
                      ["07", t("jul")],
                      ["08", t("aug")],
                      ["09", t("sep")],
                      ["10", t("oct")],
                      ["11", t("nov")],
                      ["12", t("dec")],
                    ].map((m) => (
                      <MenuItem key={m[0]} value={m[0]}>
                        {m[1]}
                      </MenuItem>
                    ))}
                    {/* <MenuItem value={"01"}>{"01"}</MenuItem>
                  <MenuItem value={"02"}>02</MenuItem>
                  <MenuItem value={"03"}>03</MenuItem> */}
                  </Select>
                </FormControl>

                <FormControl variant="standard" sx={{ minWidth: 80 }}>
                  <InputLabel id="demo-simple-select-standard-label"></InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={formData.birthDateDay}
                    onChange={handleChange}
                    label="DD"
                    name="birthDateDay"
                    required
                    sx={{ width: "60px" }}
                  >
                    {days.map((day) => (
                      <MenuItem key={day} value={day < 10 ? "0" + day : day}>
                        {day}
                      </MenuItem>
                    ))}

                    {/* <MenuItem value={"01"}>{"01"}</MenuItem>
                  <MenuItem value={"02"}>02</MenuItem>
                  <MenuItem value={"03"}>03</MenuItem> */}
                  </Select>
                </FormControl>

                <FormControl variant="standard" sx={{ minWidth: 120 }}>
                  <InputLabel id="demo-simple-select-standard-label"></InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={formData.birthDateYear}
                    onChange={handleChange}
                    required
                    label="YYYY"
                    name="birthDateYear"
                    sx={{ width: "70px" }}
                    key={1}
                  >
                    {years.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}

                    {/* <MenuItem value={"01"}>{"01"}</MenuItem>
                  <MenuItem value={"02"}>02</MenuItem>
                  <MenuItem value={"03"}>03</MenuItem> */}
                  </Select>
                </FormControl>
              </Stack>
            </Stack>
            <FormControl variant="standard" sx={{ minWidth: 120 }}>
              <InputLabel id="demo-simple-select-standard-label">
                {t("relation")}
              </InputLabel>

              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={formData.relation}
                onChange={handleChange}
                required
                label="Relation"
                name="relation"
                sx={{ width: "200px" }}
                key={2}
              >
                <MenuItem key={"Son"} value={"Son"}>
                  {t("son")}
                </MenuItem>
                <MenuItem key={"Daughter"} value={"Daughter"}>
                  {t("daughter")}
                </MenuItem>
                <MenuItem key={"Cousin"} value={"Cousin"}>
                  {t("cousin")}
                </MenuItem>
                <MenuItem key={"Other"} value={"Other"}>
                  {t("others")}
                </MenuItem>
              </Select>
            </FormControl>
          </Stack>

          <Button
            variant="outlined"
            // color="secondary"
            onClick={handleClose}
            sx={{ mt: 3 }}
          >
            {t("close")}
          </Button>

          <Button
            variant="contained"
            // color="secondary"
            onClick={handleSubmit}
            sx={{ mt: 3, ml: 6, width: "100px" }}
          >
            {t("add")}
          </Button>
        </Box>
      </Modal>
    </div>
  );
}

export default AddMinor;
